var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgBox min-w-1400"},[_c('div',{staticClass:"imgBox1 min-w-1400"},[_c('div',{staticClass:"img1Box max-w-1400"},[_c('span',[_vm._v("Copyright © CANAAN GROUP TRADING SERVICE COMPANY LIMITED-CAFOOD BRANCH")])])])])
}]

export { render, staticRenderFns }